module.exports = __webpack_public_path__ + "img/id-qtv-2.cee21e70.webp";